import { dateISOToDateAndTime } from 'Data/format.js'
import React, { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

import View from './view.js'
import TysiaText from 'DesignSystem/TysiaText/index.js'
import Message from './Message/index.js'
import Data from './DataUrl/index.js'
import Status from './Status/index.js'

export default function Logic(props) {
  let inputs = useDataValue({
    context: 'inputs',
    viewPath: props.viewPath,
  })

  let value = useMemo(() => {
    let columns = [
      {
        header: 'ID',
        accessorKey: 'id',
      },
      {
        header: 'Type',
        accessorKey: 'type',
      },

      {
        header: 'Data',
        accessorKey: 'inputs_url',
        cell: function DataUrlCell(cell) {
          return (
            <Data
              value={cell.getValue()}
              viewPath={`${props.viewPath}/DataUrl(${cell.row.original.id})`}
            />
          )
        },
      },

      {
        header: 'Location',
        accessorKey: 'location.name',
        cell: function StatusCell(cell) {
          let cellValue = cell.getValue()

          return (
            <TysiaText
              text={cellValue ?? '(by parent company)'}
              fontStyle={cellValue ? '' : 'italic'}
              viewPath={props.viewPath}
            />
          )
        },
      },
      {
        header: 'Created at',
        accessorKey: 'created_at',
      },
      {
        header: 'Created by',
        accessorKey: 'created_by',
      },
      {
        header: 'Status',
        accessorKey: 'status',
        cell: function StatusCell(cell) {
          return (
            <Status
              value={cell.getValue()}
              viewPath={`${props.viewPath}/Status(${cell.row.original.id})`}
            />
          )
        },
      },
      {
        header: 'Message',
        accessorKey: 'message',
        cell: function MessageCell(cell) {
          if (!cell.getValue()) return null
          return (
            <Message
              viewPath={`${props.viewPath}/Message(${cell.row.original.id})`}
              value={cell.row.original.message}
            />
          )
        },
      },
    ]

    if (!inputs) return { columns, data: [] }

    return {
      columns,
      data: inputs.map(item => ({
        ...item,
        created_at: dateISOToDateAndTime(item.created_at),
        created_by: item.created_by_name,
      })),
    }
  }, [inputs, props.viewPath])

  return <View value={value} viewPath={props.viewPath} />
}
